import Model from '../model';
import { BookingStatuses } from '@/common/api/config';

class BookingDetail extends Model {
  constructor(object) {
    super();
    const {
        bookingId,
        bookingNo,
        statusName,
        statusCode,
        requester,
        contactor,
        paymentInformation,
        payeeAccountInformation,
        platformRevenue,
        rejectReason,
        // cancelInformation,
        paymentChannelType,
        summary,
        statusHistory,
        rating,
        comment,
    } = object || {};

    this.bookingId = bookingId;
    this.bookingNo = bookingNo;
    this.statusName = statusName;
    this.statusCode = statusCode;
    this.requester = requester;
    this.contactor = contactor;
    this.paymentInformation = paymentInformation;
    this.payeeAccountInformation = payeeAccountInformation;
    // this.cancelInformation = cancelInformation;
    this.paymentChannelType = paymentChannelType;
    this.platformRevenue = platformRevenue;
    this.rejectReason = rejectReason;
    this.summary = summary;
    this.statusHistory = statusHistory;
    this.rating = rating;
    this.comment = comment;
  }

  get statusColorCode() {
    const colorCode = BookingStatuses.find(v => v.code === this.statusCode).color;
    return colorCode || null;
  }

  get statusBgColorCode() {
    const colorCode = BookingStatuses.find(v => v.code === this.statusCode).bgColor;
    return colorCode || null;
  }
}

export default BookingDetail;
